import { createFileRoute } from '@tanstack/react-router';
import ResetPasswordForm from '@/lib/common/components/ResetPasswordForm';

export const Route = createFileRoute('/auth/reset-password')({
    component: RouteComponent,
});

function RouteComponent() {
    return <ResetPasswordForm />;
}
